/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import { Injectable }          from '@angular/core';
import {Observable, Subject} from "rxjs";
import {TaskUpdate} from "@/models/task.update";
import {TaskUpdateClear} from "@/models/task.update.clear";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class TaskProgressService
 *
 * @brief to monitor long-running tasks from anywhere in the IDE, we use this service to
 * provide the observable stream of progress updates that can then be rendered by any
 * component in the IDE that needs to show the progress of any background tasks.
 *
 * The stream items are expected to all be TaskUpdate or some subclass of TaskUpdate.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2021
 *
 */
export class TaskProgressService {

  private subject   = new Subject<TaskUpdate>();
  private defaultId = 'default';

  /* subscribe to any and all progress updates */
  onAnyProgress():  Observable<TaskUpdate> {

    return this.subject.asObservable().pipe();
  }

  /* subscribe to progress updates; by default the alert stream 'default' */
  onProgress(id = this.defaultId): Observable<TaskUpdate> {

    /*
     * to filter by stream, we pass the normal observable through a filter pipe, so that
     * the observable they subscribe to can only get values that match the stream id.
     *
     */

    return this.subject.asObservable().pipe(filter(x => x && x.id === id));
  }

  /** publish a task progress update, if the alert stream id is not provided then 'default' */
  progress(update: TaskUpdate) {

    /* if no alert stream id is given, then just use 'default' */

    update.id = update.id || this.defaultId;

    /* publish the update */

    this.subject.next(update);
  }

  /** clear progress stream */
  clear(id = this.defaultId) {

    this.subject.next(new TaskUpdateClear(id));
  }

}
